import Swiper from 'swiper'

const mainSwiper = new Swiper('.hero-swiper', {
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  paginationClickable: true,
  speed: 1000,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 5000
  }
})

let aboutSwipers = document.querySelectorAll('.wrote-about-us')
if (aboutSwipers) {
  Array.prototype.forEach.call(aboutSwipers, (aboutSwiper, index) => {
    let next = aboutSwiper.querySelector('.swiper-button-next'),prev = aboutSwiper.querySelector('.swiper-button-prev');
    next.classList.add('swiper-button-next-'+index);
    prev.classList.add('swiper-button-prev-'+index);
    new Swiper(aboutSwiper.querySelector('.about-us-swiper'), {
      slidesPerView: 3,
      spaceBetween: 24,
      paginationClickable: true,
      autoHeight: true,
      // setWrapperSize: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.swiper-button-next-'+index,
        prevEl: '.swiper-button-prev-'+index,
      },
      breakpointsInverse: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 9
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
      }
    })
  })
}


let links = document.querySelectorAll('.menu-header-wrap a')
if (links) {
  let checkInput = document.getElementById('navcheck')
  Array.prototype.forEach.call(links, (link) => {
    link.addEventListener('click', () => {
      if (link.getAttribute('href').includes('#')) {
        checkInput.checked = false
      }
    })
  })
}